const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 819 c-53 -8 -100 -45 -110 -85 -4 -13 -13 -24 -20 -24 -30 0 -46 -30 -46 -85 0 -50 16 -85 39 -85 5 0 11 -40 13 -89 10 -170 38 -189 290 -198 151 -5 175 -4 186 10 8 9 12 26 10 39 -3 23 -6 23 -173 31 -93 5 -181 14 -195 20 -33 16 -42 70 -37 225 6 178 -13 167 286 167 285 0 276 3 287 -107 8 -79 21 -98 69 -98 49 0 65 22 65 85 0 55 -16 85 -46 85 -7 0 -16 11 -20 24 -11 43 -56 76 -120 86 -70 12 -408 11 -478 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 663 c-30 -2 -60 -9 -67 -14 -29 -25 -27 -184 4 -214 21 -22 345 -22 366 0 31 30 33 189 4 214 -14 11 -224 21 -307 14z m80 -123 l0 -40 -40 0 -40 0 0 40 0 40 40 0 40 0 0 -40z m160 0 l0 -40 -40 0 -40 0 0 40 0 40 40 0 40 0 0 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 475 c-28 -72 -46 -99 -77 -117 -18 -11 -33 -23 -33 -27 0 -3 14 -12 31 -20 22 -10 38 -29 55 -65 13 -28 24 -57 24 -63 0 -30 20 -9 35 36 16 49 41 78 84 101 l24 12 -37 21 c-34 20 -47 40 -83 127 l-11 25 -12 -30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.4e2ae79d2d763b4f3a27ccc4ff65cd2d.svg";
export { ForwardRef as ReactComponent };